import React from 'react';
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { MaintenanceReportCategories } from '../MaintenanceReportCategories';
import { Layout } from '@singularsystems/neo-canvas-grid';
import MissingAccountsReportCriteria from './MissingAccountsReportCriteria';
import { Neo } from '@singularsystems/neo-react';
import { TextConstants } from '../../../Common/TextConstants';
import { AppService, Types } from '../../../App/Services/AppService';

@NeoReport("MissingAccounts",  { category: MaintenanceReportCategories.DataValidationReports})
export default class MissingAccountsReport extends Report<MissingAccountsReportCriteria>{
    constructor(
        public serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient)
    ) {
        super(MissingAccountsReportCriteria);
    }

    public renderCriteria() {
        return (
        <>
            <Neo.GridLayout lg={3} md={3}>
                <Neo.FormGroup bindContext={this.criteria.meta.serviceProviderGroupingName} label={TextConstants.Labels.Broker}>
                    <Neo.AutoCompleteDropDown
                        itemSource={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria}
                        bind={this.criteria.meta.staticServiceProviderFileGroupingId}
                        bindDisplay={this.criteria.meta.serviceProviderGroupingName}
                        displayMember={"serviceProviderGroupingName"}
                        items={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria(" ").then((arr) => arr.data.slice(0,10)
                        .sort((x,y) => x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName)))}
                        />
                </Neo.FormGroup>
            </Neo.GridLayout>
        </>);
    }

    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}